export const green = {
    green100: '#f7fbf8',
    green200: '#f0f8f3',
    green300: '#e1f4e7',
    green400: '#d0eed9',
    green500: '#bce7c9',
    green600: '#a2dcb5',
    green700: '#7ecd9a',
    green800: '#3fb975',
    green900: '#12b76a',
    green1000: '#00ab5f',
    green1100: '#007e3e',
    green1200: '#173e26',
    greenAccentContrast: '#ffffff',
    greenAccentSurface: '#f1f9f2',
};

export const greenAlpha = {
    green100: 'rgba(40, 210, 83, 0.02)',
    green200: 'rgba(17, 174, 76, 0.05)',
    green300: 'rgba(7, 180, 61, 0.11)',
    green400: 'rgba(2, 172, 53, 0.18)',
    green500: 'rgba(1, 170, 52, 0.25)',
    green600: 'rgba(3, 164, 56, 0.36)',
    green700: 'rgba(0, 158, 56, 0.5)',
    green800: 'rgba(1, 164, 73, 0.75)',
    green900: 'rgba(0, 178, 95, 0.93)',
    green1000: '#00ab5f',
    green1100: '#007e3e',
    green1200: 'rgba(0, 43, 17, 0.91)',
    greenAccentContrast: '#ffffff',
    greenAccentSurface: 'rgba(238, 248, 240, 0.8)',
};

export const greenDark = {
    green100: '#0c130e',
    green200: '#121b15',
    green300: '#152c1d',
    green400: '#113c23',
    green500: '#164a2c',
    green600: '#1d5937',
    green700: '#226a41',
    green800: '#257d4d',
    green900: '#12b76a',
    green1000: '#00ab5f',
    green1100: '#46d686',
    green1200: '#aff4c5',
    greenAccentContrast: '#ffffff',
    greenAccentSurface: '#121b14',
};

export const greenDarkAlpha = {
    green100: 'rgba(0, 187, 0, 0.01)',
    green200: 'rgba(41, 249, 110, 0.04)',
    green300: 'rgba(53, 255, 123, 0.11)',
    green400: 'rgba(17, 251, 115, 0.18)',
    green500: 'rgba(38, 252, 129, 0.24)',
    green600: 'rgba(57, 253, 142, 0.31)',
    green700: 'rgba(62, 253, 144, 0.38)',
    green800: 'rgba(61, 255, 149, 0.45)',
    green900: 'rgba(19, 255, 145, 0.7)',
    green1000: 'rgba(0, 255, 138, 0.65)',
    green1100: 'rgba(81, 254, 158, 0.83)',
    green1200: 'rgba(182, 254, 205, 0.96)',
    greenAccentContrast: '#ffffff',
    greenAccentSurface: 'rgba(18, 36, 23, 0.5)',
};
